// Import model
import { EstimateSection } from '../models/EstimateSection';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for EstimateSection - handles JSON serialization and deserialization with type validation
 */
export class EstimateSectionSerializer {
  /**
   * Deserializes a JSON string into a EstimateSection instance
   */
  static deserialize(json: string): EstimateSection {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a EstimateSection instance
   */
  static fromObject(obj: any): EstimateSection {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to EstimateSection');
    }


    const instance: EstimateSection = {
      content: obj['content'] as string | undefined,
      contentType: obj['contentType'] as string | undefined,
      name: obj['name'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of EstimateSection instances
   */
  static deserializeArray(json: string): EstimateSection[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a EstimateSection instance to a JSON string
   */
  static serialize(instance: EstimateSection): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a EstimateSection instance to a plain object
   */
  static toObject(instance: EstimateSection): any {
    return {
      'content': instance.content,
      'contentType': instance.contentType,
      'name': instance.name,
    };
  }

  /**
   * Serializes an array of EstimateSection instances to a JSON string
   */
  static serializeArray(instances: EstimateSection[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
